<form *ngIf="form" [formGroup]="form" class="generic-form-fields">
  <dx-lookup formControlName="workerId" [gsResource]="workers" valueExpr="id"  displayExpr="name" [label]="'entity.attendanceEntry.workerName' | translate"></dx-lookup>
  <dx-date-box type="datetime" formField required formControlName="entryIn" [label]="'entity.attendanceEntry.entryIn' | translate"/>
  <dx-date-box type="datetime" formField formControlName="entryOut" [label]="'entity.attendanceEntry.entryOut' | translate"/>
  <gs-time-span-field
                      [label]="'entity.attendanceEntry.attendanceTime' | translate"
                      formField required formControlName="attendanceTime"

  />
</form>